export default "__VITE_ASSET__DaycAQUh__"